import {
  AdAnalyticsDailyPerformance,
  AdAnalyticsVideo,
  AdAnalyticsVideoFilter,
  AdAnalyticsVideoSort,
} from '@kaizenplatform/hugot-entity';
import { List } from 'immutable';

import State from '../core/State';
import WithTotalCountArrayPageInfo from '../entity/WithTotalCountArrayPageInfo';

export const startFetchingAdAnalyticsVideos = () => (state: State): State => ({
  ...state,
  adAnalyticsVideos: {
    ...state.adAnalyticsVideos,
    fetching: state.adAnalyticsVideos.fetching + 1,
  },
});

export const finishFetchingAdAnalyticsVideos = () => (state: State): State => ({
  ...state,
  adAnalyticsVideos: {
    ...state.adAnalyticsVideos,
    fetching: state.adAnalyticsVideos.fetching - 1,
  },
});

export const startFetchingAppendAdAnalyticsVideos = () => (state: State): State => ({
  ...state,
  adAnalyticsVideos: {
    ...state.adAnalyticsVideos,
    appendFetching: state.adAnalyticsVideos.fetching + 1,
  },
});

export const finishFetchingAppendAdAnalyticsVideos = () => (state: State): State => ({
  ...state,
  adAnalyticsVideos: {
    ...state.adAnalyticsVideos,
    appendFetching: state.adAnalyticsVideos.fetching - 1,
  },
});

export const setAdAnalyticsVideos = (
  adAnalyticsVideos: List<AdAnalyticsVideo>,
  pageInfo: WithTotalCountArrayPageInfo,
) => (state: State): State => ({
  ...state,
  adAnalyticsVideos: {
    ...state.adAnalyticsVideos,
    items: adAnalyticsVideos,
    pageInfo,
  },
});

export const appendAdAnalyticsVideos = (
  adAnalyticsVideos: List<AdAnalyticsVideo>,
  pageInfo: WithTotalCountArrayPageInfo,
) => (state: State): State => ({
  ...state,
  adAnalyticsVideos: {
    ...state.adAnalyticsVideos,
    items:
      state.adAnalyticsVideos.items === null
        ? adAnalyticsVideos
        : state.adAnalyticsVideos.items.concat(adAnalyticsVideos),
    pageInfo: pageInfo,
  },
});

export const disposeAdAnalyticsVideos = () => (state: State): State => ({
  ...state,
  adAnalyticsVideos: {
    ...state.adAnalyticsVideos,
  },
});

// @TODO 別ファイルに分けた方が綺麗？
export const setAdAnalyticsDailyPerformances = (dailyPerformances: List<AdAnalyticsDailyPerformance>) => (
  state: State,
): State => ({
  ...state,
  adAnalyticsVideos: {
    ...state.adAnalyticsVideos,
    dailyPerformances,
  },
});

export const setPerPage = (perPage: number) => (state: State): State => ({
  ...state,
  adAnalyticsVideos: {
    ...state.adAnalyticsVideos,
    perPage,
  },
});

export const setCurrentPage = (currentPage: number) => (state: State): State => ({
  ...state,
  adAnalyticsVideos: {
    ...state.adAnalyticsVideos,
    currentPage,
  },
});

export const setSubmitReport = (success: boolean) => (state: State): State => ({
  ...state,
  adAnalyticsVideos: {
    ...state.adAnalyticsVideos,
    submitReport: success,
  },
});

export const updateSelectedVideos = (selectedVideos: List<AdAnalyticsVideo>) => (state: State): State => ({
  ...state,
  adAnalyticsVideos: {
    ...state.adAnalyticsVideos,
    selectedVideos: selectedVideos,
  },
});

export const updateFilters = (filters: AdAnalyticsVideoFilter[]) => (state: State): State => ({
  ...state,
  adAnalyticsVideos: {
    ...state.adAnalyticsVideos,
    filters: filters,
  },
});

export const updateSort = (sort: AdAnalyticsVideoSort) => (state: State): State => ({
  ...state,
  adAnalyticsVideos: {
    ...state.adAnalyticsVideos,
    sort: sort,
  },
});
